import { render } from "./ProjectsWithNations.vue?vue&type=template&id=531dd1f3&scoped=true&ts=true"
import script from "./ProjectsWithNations.vue?vue&type=script&lang=ts"
export * from "./ProjectsWithNations.vue?vue&type=script&lang=ts"

import "./ProjectsWithNations.vue?vue&type=style&index=0&id=531dd1f3&lang=scss&scoped=true"

import exportComponent from "/builds/vei/portal/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-531dd1f3"]])

export default __exports__